import { capitalizeFirstLetter } from "@saviynt/common";
import { Chip, ChipColorTypes } from "@saviynt/design-system";

export const Status = ({ text }: { text: string }) => {
  let color: ChipColorTypes = "neutral";
  let label = capitalizeFirstLetter(text);

  switch (text.toLocaleUpperCase()) {
    case "ACTIVE":
      color = "success";
      label = "Active";
      break;
    case "DISABLED":
      color = "neutral";
      label = "Disabled";
      break;
  }

  return <Chip kind="boldFilled" size="small" label={label} color={color} />;
};
